import { useState } from "react";
import { playParts } from "../../multi/playParts";
import { isPartError } from "../../multi/parseParts";
import { PartRunner } from "../../multi/runParts";

/** UI for editing & playing dialog */
export function DialogArea(props: {
  dialogText: string, cols?: number, rows?: number
}
) {
  const [partText, setPartText] = useState(props.dialogText);
  const [partError1, setPartError1] = useState<string | undefined>(undefined);
  const [partError2, setPartError2] = useState<string | undefined>(undefined);
  const cols = props.cols ?? 80;
  const rows = props.rows ?? 10;

  function tryPlayParts() {
    setPartError1(undefined);
    setPartError2(undefined);
    const result = playParts(partText);
    if (isPartError(result)) {
      setPartError1(result.partError);
      setPartError2(result.content);
    }
  }

  return (<>
    <button onClick={() => tryPlayParts()}>play parts</button>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <button onClick={() => PartRunner.stopParts()}>stop</button>
    <br />

    <textarea cols={cols} rows={rows} spellCheck={false} value={partText}
      onChange={(e) => setPartText(e.target.value)} />
    {partError1 ? <><br />error: <b>{partError1}</b></> : <></>}
    {partError2 ? <><br />content: <b>{partError2}</b></> : <></>}
  </>);
}
